import React, { useEffect, useState } from "react";
import Charts from 'components/main/Charts';
import Tabs from 'components/main/Tabs';
import Map from 'components/main/Map';
import NoData from 'components/main/NoData';
import Observations from 'components/main/Observations';
import { useSelector } from 'react-redux';


export default function TabsContainer() {
  const [active, setActive] = useState("map")
  const geoAreas = useSelector((state) => state.geoAreas);
  const observations = useSelector((state) => state.observations);


  useEffect(() => { 
    console.log('render TabsContainer')
  });

  if (active != "NoData" && (!geoAreas || Object.keys(geoAreas).length == 0)) return setActive("NoData")


  return (
      <div className="cell relative" id="mapContainer">
        {observations && <Observations/>}
        {active == "charts" && <Charts/>}
        {active == "map" && <Map setActive={setActive}/>}
        {active == "NoData" && <NoData />}
        <Tabs active={active} setActive={setActive}/>
      </div>
  )
}